<template>
  <div>
    <form class="form-inline" v-on:submit.prevent="onSubmit(title)">
      <div class="form-group">
        <input type="text" class="form-control" v-model="title" />
      </div>
      <button type="submit"
        class="btn btn-secondary ml-2"
        :disabled="state.isSaving">
        <span class="spinner-border spinner-border-sm ml-3" role="status" v-if="state.isSaving" />
        Change
      </button>
      <button type="button"
        class="btn btn-link btn-sm" @click="state.isEditing = false">Cancel</button>
    </form>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    value: { type: String, default: '' },
    state: { type: Object, default: () => {} },
    onSubmit: { type: Function, default: () => {} },
  },
  data() {
    return {
      title: null,
    };
  },
  created() {
    this.title = _.cloneDeep(this.value);
  },
};
</script>

<style lang="scss" scoped>

</style>
